import Typography from "@atoms/typography/Typography";
import { gridStyles } from "@layout/grid";
import { cn } from "@utils/tailwind";
import { FC } from "react";

export type SearchSuggestionsProps = {
  suggestions: string[];
  onChange: (suggestion: string) => void;
  show?: boolean;
};

export const SearchSuggestions: FC<SearchSuggestionsProps> = ({
  suggestions,
  onChange,
  show = true,
}) => (
  <div className={cn(gridStyles.itemShrinked, show ? "block" : "hidden")}>
    <Typography tag="h2" variant="h3" className="mb-4 md:mb-5">
      Frequent searches
    </Typography>
    <div className="flex flex-col items-start gap-4 2xl:gap-3">
      {suggestions.map((it) => (
        <button
          key={it}
          onClick={() => onChange(it)}
          className="border-b border-transparent transition-colors duration-300 ease-in hover:border-current focus:border-current"
        >
          <Typography tag="span" variant="base" weight="medium">
            {it}
          </Typography>
        </button>
      ))}
    </div>
  </div>
);
